import React, { useEffect } from 'react';
import './BlockEditor.css';

interface ImageLightboxProps {
  imageUrl: string;
  onClose: () => void;
  metadata?: {
    originalName?: string;
    width?: number;
    height?: number;
  };
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ imageUrl, onClose, metadata }) => {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  // Prevent body scroll when lightbox is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-lightbox-backdrop" onClick={handleBackdropClick}>
      <div className="image-lightbox-content">
        <button 
          className="image-lightbox-close"
          onClick={onClose}
          aria-label="Close image"
        >
          ×
        </button>
        <img 
          src={imageUrl} 
          alt={metadata?.originalName || 'Image'} 
          className="image-lightbox-image"
        />
        {metadata && (metadata.originalName || metadata.width || metadata.height) && (
          <div className="image-lightbox-metadata">
            {metadata.originalName && (
              <span className="image-lightbox-filename">{metadata.originalName}</span>
            )}
            {metadata.width && metadata.height && (
              <span className="image-lightbox-dimensions">
                {metadata.width} × {metadata.height}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageLightbox;

